import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useEffect, useRef } from 'react';
import startOptionalTestAuthSignIn, {
  type OptionalTestAuthSignIn,
} from '@/testing/startOptionalTestAuthSignIn';
import useHandleAuthStateChange from './useHandleAuthStateChange';

export default function useInitializeAuth() {
  const handleAuthStateChange = useHandleAuthStateChange();

  const testAuthSignInRef = useRef<OptionalTestAuthSignIn | undefined>(
    undefined,
  );

  useEffect(() => {
    const auth = getAuth();
    let isSubscribed = true;

    if (testAuthSignInRef.current === undefined) {
      testAuthSignInRef.current = startOptionalTestAuthSignIn(auth);
    }

    const testAuthSignIn = testAuthSignInRef.current;

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user && testAuthSignIn) {
        void testAuthSignIn.then(() => {
          if (isSubscribed) {
            handleAuthStateChange(auth.currentUser);
          }
        });
        return;
      }

      handleAuthStateChange(user);
    });

    return () => {
      isSubscribed = false;
      unsubscribe();
    };
  }, [handleAuthStateChange]);
}
